import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, IconButton, Tooltip } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import L from 'leaflet'; 

// A small component for the colored circle
function ColorCircle({ color, isVisible }) {
  const style = {
    width: 18,
    height: 18,
    borderRadius: '50%',
    border: '2px solid rgba(0,0,0,0.3)',
    display: 'inline-block',
  };

  if (isVisible) {
    style.backgroundColor = color;
  } else {
    // This creates the "red and white line diagonal"
    style.backgroundColor = '#fff';
    style.backgroundImage = 'linear-gradient(to top left, transparent 47%, red 47%, red 53%, transparent 53%)';
  }

  return <Box component="span" sx={style} />;
}

// Updated MapLegend
function MapLegend({ visibility, onToggle }) {
  const [isOpen, setIsOpen] = useState(true); 
  const legendRef = useRef(null); 

  useEffect(() => {
    if (legendRef.current) {
      L.DomEvent.disableClickPropagation(legendRef.current);
      L.DomEvent.disableScrollPropagation(legendRef.current);
    }
  }, []); 

  // --- UPDATED to include 'postcodes' ---
  const legendItems = [
    { key: 'public', color: '#f03', text: 'Public Display' },
    { key: 'myCompleted', color: '#FFD700', text: 'My Completed Display' },
    { key: 'myPending', color: 'orange', text: 'My Pending Display' },
    { key: 'route', color: 'green', text: 'My Route' },
    { key: 'myLocation', color: '#007bff', text: 'My Location' },
    { key: 'postcodes', color: '#1E90FF', text: 'Postcodes' },
    { key: 'fireworks', color: '#9c27b0', text: 'NYE Fireworks' }
  ];

  return (
    <Box
      ref={legendRef} 
      sx={{
        position: 'absolute',
        bottom: 20,
        right: 10,
        zIndex: 1000,
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        opacity: 0.9,
        padding: '10px',
        maxWidth: 200, 
      }}
    >
      {/* Clickable header */}
      <Box 
        onClick={() => setIsOpen(!isOpen)} 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          cursor: 'pointer' 
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
          Legend
        </Typography>
        <IconButton size="small">
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      {/* Collapsible content */}
      {isOpen && (
        <List dense sx={{ paddingTop: '5px' }}>
          {legendItems.map((item) => (
            <Tooltip 
              key={item.key} 
              title="Click to toggle visibility" 
              placement="left" 
              arrow
            >
              <ListItem 
                sx={{ p: 0, cursor: 'pointer' }}
                onClick={() => onToggle(item.key)} 
              >
                <ListItemIcon sx={{ minWidth: '30px' }}>
                  <ColorCircle color={item.color} isVisible={visibility[item.key]} />
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            </Tooltip>
          ))}
        </List>
      )}
    </Box>
  );
}

export default MapLegend;